export enum globalEvents {
  SET_CREDENTIALS = "SET-CREDENTIALS",
  USER_CLEAR = "USER-CLEAR",
  APPOINTMENT_RESCHEDULED = "APPOINTMENT-RESCHEDULED",
  /**
   * Fired when the authenticated user ID changes (from parsed access token).
   * Use this to reload user-specific cached data.
   * Unlike SET_CREDENTIALS, this only fires when the actual user changes,
   * not on token refresh for the same user.
   */
  USER_CHANGED = "USER-CHANGED"
}
